import React, { useEffect, useState } from "react";
import axios from "axios";
import { ACCESS_KEY } from "../config";
import "./HostRewardSetting.css";

const API_BASE = "https://admin.butterlive.co.in";

const DEFAULT_SLABS = [
  { minutes: 30, amount: 0 },
  { minutes: 30, amount: 0 },
  { minutes: 30, amount: 0 },
  { minutes: 30, amount: 0 },
];

const createDefaultSettings = () => ({
  eligibility: "FEMALE",

  newHost: {
    male: DEFAULT_SLABS.map((slab) => ({ ...slab })),
    female: DEFAULT_SLABS.map((slab) => ({ ...slab })),
  },

  oldHost: {
    male: DEFAULT_SLABS.map((slab) => ({ ...slab })),
    female: DEFAULT_SLABS.map((slab) => ({ ...slab })),
  },
});

function HostRewardSetting() {
  const [settings, setSettings] = useState(createDefaultSettings());
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${API_BASE}/hostReward/settings`,
        {
          headers: {
            key: ACCESS_KEY,
          },
        }
      );

      if (response.data.status && response.data.data) {
        setSettings(response.data.data);
      } else {
        alert(
          response.data.message ||
            "Failed to load Host Reward settings."
        );
      }
    } catch (error) {
      console.error("Error fetching Host Reward settings:", error);

      alert(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to load Host Reward settings."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleEligibilityChange = (value) => {
    setSettings((prev) => ({
      ...prev,
      eligibility: value,
    }));
  };

  const handleAmountChange = (
    hostType,
    gender,
    index,
    value
  ) => {
    setSettings((prev) => {
      const updatedHost = {
        ...prev[hostType],
        [gender]: prev[hostType][gender].map(
          (slab, slabIndex) =>
            slabIndex === index
              ? {
                  ...slab,
                  amount:
                    value === "" ? "" : Number(value),
                }
              : slab
        ),
      };

      return {
        ...prev,
        [hostType]: updatedHost,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);

      const response = await axios.post(
        `${API_BASE}/hostReward/settings`,
        settings,
        {
          headers: {
            key: ACCESS_KEY,
          },
        }
      );

      if (response.data.status) {
        setSettings(response.data.data);
        alert("Host Reward settings saved successfully!");
      } else {
        alert(
          response.data.message ||
            "Failed to save Host Reward settings."
        );
      }
    } catch (error) {
      console.error("Error saving Host Reward settings:", error);

      alert(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to save Host Reward settings."
      );
    } finally {
      setSaving(false);
    }
  };

  const renderHostSection = (hostType, title) => {
    const hostSettings = settings[hostType];

    return (
      <div className="host-reward-card">
        <div className="host-reward-card-header">
          <h2>{title}</h2>
        </div>

        <div className="reward-table">
          <div className="reward-table-header">
            <div>Gender</div>
            <div>Slab 1</div>
            <div>Slab 2</div>
            <div>Slab 3</div>
            <div>Slab 4</div>
          </div>

          {["male", "female"].map((gender) => (
            <div className="reward-table-row" key={gender}>
              <div className="gender-label">
                {gender === "male" ? "Male" : "Female"}
              </div>

              {hostSettings[gender].map((slab, index) => (
                <div className="reward-input-cell" key={index}>
                  <span className="minute-label">
                    {index + 1 === 1 && "30 min"}
                    {index + 1 === 2 && "60 min"}
                    {index + 1 === 3 && "90 min"}
                    {index + 1 === 4 && "120 min"}
                  </span>

                  <input
                    type="number"
                    min="0"
                    value={slab.amount}
                    onChange={(e) =>
                      handleAmountChange(
                        hostType,
                        gender,
                        index,
                        e.target.value
                      )
                    }
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="host-reward-loading">
        Loading Host Reward settings...
      </div>
    );
  }

  return (
    <div className="host-reward-page">
      <div className="page-header">
        <h1 className="page-title">
          Host Reward Setting
        </h1>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="host-reward-card eligibility-card">
          <div className="host-reward-card-header">
            <h2>Host Eligibility</h2>
          </div>

          <div className="eligibility-buttons">
            <button
              type="button"
              className={
                settings.eligibility === "FEMALE"
                  ? "eligibility-btn selected"
                  : "eligibility-btn"
              }
              onClick={() =>
                handleEligibilityChange("FEMALE")
              }
            >
              Female
            </button>

            <button
              type="button"
              className={
                settings.eligibility === "BOTH"
                  ? "eligibility-btn selected"
                  : "eligibility-btn"
              }
              onClick={() =>
                handleEligibilityChange("BOTH")
              }
            >
              Both
            </button>
          </div>
        </div>

        {renderHostSection("newHost", "New Host")}
        {renderHostSection("oldHost", "Old Host")}

        <div className="host-reward-submit-area">
          <button
            type="submit"
            className="host-reward-save-btn"
            disabled={saving}
          >
            {saving ? "Saving..." : "Save Settings"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default HostRewardSetting;
